import React from 'react';

export default () => (
	<svg
		style={{marginLeft: 2}}
		width="9px"
		height="16px"
		viewBox="0 0 9 16">
		<g
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			strokeLinecap="round"
			strokeLinejoin="round">
			<path
				d="M1.00000003,1.4375 L7.25333339,7.69083336 C7.33540578,7.77278895 7.3815234,7.8840147 7.3815234,8.00000003 C7.3815234,8.11598535 7.33540578,8.22721111 7.25333339,8.3091667 L1.00000003,14.5625001"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</g>
	</svg>
);